/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
// import {useIntl} from 'react-intl'
// import {PageTitle} from '../../../_metronic/layout/core'
// import { DashboardMainRK } from '../../modules/dashboard/views/DashboardMainRK'
import {DashboardMainPage} from '../../modules/dashboard/views/DashboardMainPage'
import {EarlyAccessInvite} from '../../modules/dashboard/views/EarlyAccessInvite'
import {useAuth} from '../../modules/auth'
import {DashboardMainRK} from '../../modules/dashboard/views/DashboardMainRK'
import ActivateSubscription from '../../modules/dashboard/views/ActivateSubscription'
// import ActivateSubscription from '../../modules/dashboard/views/ActivateSubscription'

const DashboardWrapper: FC = () => {
  // const intl = useIntl()
  const {companyQueuePosition, planStatus} = useAuth()
  const isRkAppReady = process.env.REACT_APP_RK_APP_IS_READY === 'true'
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'My Dashboard'})}</PageTitle> */}
      {(!isRkAppReady && isRecordskeeper && companyQueuePosition !== 0) ||
      (companyQueuePosition !== 0 && isRecordskeeper) ? (
        <EarlyAccessInvite />
      ) : isRecordskeeper ? (
        planStatus === 'cancelled' ? (
          <ActivateSubscription />
        ) : (
          <DashboardMainRK />
          // <ActivateSubscription />
        )
      ) : (
        <DashboardMainPage />
      )}
    </>
  )
}

export {DashboardWrapper}
